module.exports = __webpack_public_path__ + "static/media/bg11.528e9d3b.jpg";